import axios from "axios";
import React, { useEffect, useState } from "react";
import { UserOutlined, LockOutlined, LoginOutlined, RocketFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { getAccessToken, apiUrl } from "../../common/apis";
import { startSession } from "../../common/session";
import styles from "./login.module.css";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (getAccessToken()) {
      navigate("/");
    }
  }, [navigate]);

  const signIn = (e) => {
    e?.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.warning("Please enter your username and password");
      return;
    }

    setIsLoading(true);
    const data = new FormData();
    data.append("username", username.trim());
    data.append("password", password.trim());

    const config = {
      method: "post",
      url: `${apiUrl}user/login/`,
      data: data,
    };

    axios(config)
      .then((response) => {
        setIsLoading(false);
        if (
          response.data.is_deliveryboy_blocked === true ||
          response.data.is_deliveryboy === false ||
          response.data.Status === false ||
          response.data.Status === "False"
        ) {
          toast.warning("Please contact the admin to activate your delivery account");
        } else {
          toast.success("Login successful! Welcome back.");
          const expirationDate = new Date();
          expirationDate.setFullYear(expirationDate.getFullYear() + 1);
          startSession(response.data.token, { expires: expirationDate });
          navigate("/");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response && err.response.status === 400) {
          toast.error("Invalid username or password");
        } else {
          toast.error(err.response?.data?.Message || err.response?.data?.Error || "An error occurred while logging in");
        }
      });
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.brandIconWrapper}>
          <RocketFilled />
        </div>

        <h1 className={styles.brandTitle}>FOODOOR</h1>
        <p className={styles.brandSubtitle}>Delivery Partner Portal</p>

        <form onSubmit={signIn}>
          <div className={styles.formGroup}>
            <label className={styles.inputLabel} htmlFor="loginUsername">
              Username
            </label>
            <div className={styles.inputWrapper}>
              <UserOutlined className={styles.inputIcon} />
              <input
                id="loginUsername"
                placeholder="Enter your username"
                type="text"
                value={username}
                className={styles.inputField}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.inputLabel} htmlFor="loginPassword">
              Password
            </label>
            <div className={styles.inputWrapper}>
              <LockOutlined className={styles.inputIcon} />
              <input
                id="loginPassword"
                placeholder="Enter your password"
                type="password"
                value={password}
                className={styles.inputField}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
          </div>

          <button type="submit" disabled={isLoading} className={styles.submitBtn}>
            <LoginOutlined style={{ color: "#ffffff" }} />
            <span style={{ color: "#ffffff" }}>{isLoading ? "Signing in..." : "Login"}</span>
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
